import classNames from "classnames";
import React, { useEffect, useRef } from "react";

import styles from "./Bookmark.module.scss";

interface Props {
  label: string;
  isActive?: boolean;
  onSelect?: () => void;
  autoScrollTo?: boolean;
}

function Bookmark(props: Props) {
  const container = useRef<HTMLDivElement | null>(null);
  const { label, isActive = false, onSelect } = props;
  useEffect(() => {
    // a little hack here to improve UX
    if (props.autoScrollTo) {
      if (
        container.current &&
        container.current?.parentElement?.parentElement
      ) {
        container.current.parentElement.parentElement.scrollTo({
          left: container.current?.offsetLeft,
        });
      }
    }
  }, []);

  return (
    <div
      className={classNames(styles.bookmark, { [styles.active]: isActive })}
      onClick={onSelect}
      ref={container}
    >
      <div className={classNames(styles.label, { [styles.active]: isActive })}>
        {label}
      </div>
      {isActive && <div className={styles.line} />}
    </div>
  );
}

export default Bookmark;
